// extracted by mini-css-extract-plugin
export default {"base":"vp_MbAiv","item":"vp_EfNxw","overlay":"vp_O9Efo","content":"vp_B6GQG"};